/**
 * Token Storage Utility
 * Responsible for managing the authentication token in localStorage.
 */

const TOKEN_KEY = 'auth_token';

export const getToken = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(TOKEN_KEY);
  }
  return null;
};

export const setToken = (token) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(TOKEN_KEY, token);
  }
};

export const removeToken = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(TOKEN_KEY);
  }
};

const tokenStorage = {
  getToken,
  setToken,
  removeToken,
};

export default tokenStorage;
